export default __webpack_public_path__ + "static/media/sacrifice.2a4f66f4.png";